import {
  correctColor,
  fixOptions,
  NumberToLetter,
} from "../../constants/Constants";
import Div from "../../components/common/Div";
import React from "react";
import { Tex } from "react-tex";
import Image from "../../components/common/Image";

export default function M_SelectTrue(props) {
  const question = props.question;
  const options = question.options;

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {texCon}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function getCorrectOptions() {
    var corr = [];

    for (var x = 0; x < options.length; x++) {
      if (options[x].correct === 1) {
        corr[corr.length] = NumberToLetter(x);
      }
    }

    var text = "";

    for (var x = 0; x < corr.length; x++) {
      if (x === 0) {
        text = corr[x];
      } else {
        text = text + " ; " + corr[x];
      }
    }
    return text;
  }
  return (
    <>
      <div>
        {Options()}
        <div
          style={{
            width: "45%",
            backgroundColor: correctColor(),
            borderRadius: "5px",
          }}
        >
          <text>{getCorrectOptions()}</text>
        </div>
      </div>
    </>
  );
}
